
import { BasicModel } from "@goodgamestudios/core";
import { BasicDialogHandler } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2AntiCheatEvent } from "../../../event/Poker2AntiCheatEvent";
import { Poker2OnTableEvent } from "../../../event/Poker2OnTableEvent";
import { TournamentResultVO } from "../../../gamevo/TournamentResultVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2SitnGoResultDialog } from "../../../view/dialogs/sitngo/Poker2SitnGoResultDialog";
import { Poker2SitnGoResultDialogProperties } from "../../../view/dialogs/sitngo/Poker2SitnGoResultDialogProperties";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";

export class SENCommand extends Poker2Command {
    protected get cmdId(): string {
        return "sen";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var resultVO: TournamentResultVO = Poker2Model.onSitnGoData.parse_SEN(JSON.parse(params[1]));

            console.log("SENCommand, resultVO: " + resultVO.toString());

            BasicDialogHandler.getInstance().registerDialogs("Poker2SitnGoResultDialog", new Poker2SitnGoResultDialogProperties(resultVO), true, BasicDialogHandler.PRIORITY_TOP);

            if (Poker2Model.onTableData.playersSeatIndex && Poker2Model.onTableData.playersSeatIndex.length == 0) {
                console.log("SENCommnad, playersSeatIndex: " + Poker2Model.onTableData.playersSeatIndex.length);

                // TODO: "onTableData.playersSeatIndex" is one at this time! Maybe the model wasn't updated in that moment or the array
                // wasn't updated. Try find a better solution (maybe count the seats!)
                // no players left, tournament over. Jump back to lobby
                this.leaveToLobby();
            }
            else {
                console.log("SENCommnad, TABLE_STAND_UP");

                // sitngo is going on. Stand up player and make him a spectator.
                this.controller.dispatchEvent(new Poker2OnTableEvent("standUp", [{ unlockSeats: false }]));
            }
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    private leaveToLobby(): void {
        if (this.layoutManager.currentState == 10) {
            BasicDialogHandler.getInstance().blockDialogs = false;
            BasicModel.smartfoxClient.sendMessage("tle", []);
            this.controller.dispatchEvent(new Poker2AntiCheatEvent("antiCheatRemoveConnection"));
        }
        this.layoutManager.state = 11;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
